<template>
  <v-container fluid>
    <v-row class="pa-0" align="start" justify="space-around">
      <v-col cols="9" class="pa-0">
        <v-btn
            v-for="link in links"
            :key="link.title"
            text
            rounded
            x-small
            class="my-2"
            :href="link.href"
        >
          <v-icon small light color="blue-grey darken-3" class="pr-1">{{ link.icon }}</v-icon>
          {{ link.title }}
        </v-btn>
      </v-col>

      <v-col class="pa-0">
        <div class="text--accent-1 text-caption text-right pt-2" style="width: 100%">v{{ appVersion }}</div>
      </v-col>


    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AppFooter",
  data: () => ({
    links: [
      {title: 'Home', href: './', icon: 'mdi-home'},
      {title: 'Feedback/Support', href: 'https://fissupport.ipf.msu.edu/', icon: 'mdi-help-box'},
      {title: 'Request Secured Access', href: './account-request', icon: 'mdi-lock'}
    ]
  }),

  computed: {
    appVersion() {
      return this.$store.state.system.version
    },
  }

}
</script>

<style scoped>
.app-footer {
  min-height: 70px;
}
</style>
